/**
 * Nome para salvar o lead na agenda do WhatsApp, com o que ajuda a achar depois:
 *   "Cintia Moreira - Lotapar Participações - Cenários virtuais com IA - Produxia"
 *
 * O interesse vem do que a PESSOA marcou no formulário do site ("Interesse: ..." nas
 * notas). Sem isso, cai no tipo de serviço do card, encurtado: ele às vezes guarda
 * uma descrição longa, e nome de contato comprido corta na tela do celular.
 * Partes vazias somem, para não sobrar "- -".
 */
const MAX_INTERESSE = 40;

function interesseDo(lead) {
  const m = String(lead.notes || '').match(/^\s*Interesse:\s*(.+)$/mi);
  let t = m ? m[1] : String(lead.service_type || '');
  t = t.split(/\s+·\s+|\s*\(|\n/)[0].trim();
  if (t.length > MAX_INTERESSE) t = t.slice(0, MAX_INTERESSE).replace(/\s+\S*$/, '').trim();
  return t;
}

/** Tira anotação entre colchetes: "Pozze [Black Friday]" vira "Pozze", "Paulo [Dono da Leaf]" vira "Paulo". */
const limpa = (nome) => String(nome || '').replace(/\s*\[[^\]]*\]\s*/g, ' ').replace(/\s+/g, ' ').trim();

function nomeParaAgenda(lead, nossaEmpresa = '') {
  const pessoa = limpa(lead.contact_name);
  const empresa = limpa(lead.company_name);
  const partes = [pessoa, empresa !== pessoa ? empresa : '', interesseDo(lead), String(nossaEmpresa || '').trim()];
  return partes.filter(Boolean).join(' - ');
}

export { interesseDo, nomeParaAgenda };
